/**
 * Escape user data before injecting into a ZPL field.
 * `^`, `~`, `\` are the ZPL control/prefix characters and must be neutralised.
 */
export function escapeZplField(value: string | number | undefined | null): string {
  if (value === null || value === undefined) return "";
  return String(value)
    .replace(/\\/g, "\\\\")
    .replace(/\^/g, "\\^")
    .replace(/~/g, "\\~");
}
